var _rect, _circle, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 24,
    viewBox: "0 0 55 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2278_14688)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 24,
    rx: 12,
    fill: "#0088FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 12,
    r: 10,
    fill: "#FFCC33"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2278_14688",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -8,
    y: 0,
    width: 41,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -8,
    width: 41,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2278_14688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 4C2.65685 4 4 5.34315 4 7C4 7.77245 3.70515 8.4741 3.22559 9.00586C5.72261 9.11675 7.74266 11.0583 7.97656 13.5215C8.92161 13.1845 9.93921 13 11 13C15.8173 13 19.7503 16.7848 19.9883 21.543C20.5794 21.1983 21.2664 21 22 21C24.1331 21 25.8757 22.6697 25.9932 24.7734C26.5249 24.2938 27.2275 24 28 24C29.6569 24 31 25.3431 31 27C31 28.6569 29.6569 30 28 30C26.5412 30 25.3255 28.9589 25.0557 27.5791C24.3219 28.4475 23.2259 29 22 29C21.4589 29 20.9434 28.891 20.4727 28.6963C19.9319 29.4831 19.0269 30 18 30C17.3073 30 16.6709 29.7634 16.1631 29.3691C14.7012 30.3953 12.9218 31 11 31C9.14964 31 7.43019 30.4409 6 29.4834C4.56981 30.4409 2.85036 31 1 31C-3.97056 31 -8 26.9706 -8 22C-8 18.0727 -5.48421 14.7338 -1.97656 13.5049C-1.8288 12.0015 -1.01457 10.6935 0.166016 9.87988C-1.08471 9.51832 -2 8.3672 -2 7C-2 5.34315 -0.656854 4 1 4Z",
    fill: "#E7F2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.27246 0C5.07985 0 6.54575 1.46511 6.5459 3.27246C6.5459 4.11501 6.22419 4.88087 5.70117 5.46094C8.42482 5.58216 10.6275 7.70003 10.8828 10.3867C11.9139 10.0189 13.0243 9.81838 14.1816 9.81836C19.2586 9.81836 23.4346 13.6717 23.9463 18.6133C25.9128 18.9609 27.4244 20.6243 27.5381 22.6621C28.1182 22.1389 28.8848 21.8184 29.7275 21.8184C31.5349 21.8185 33 23.2835 33 25.0908C33 26.8982 31.5349 28.3631 29.7275 28.3633C28.1359 28.3633 26.8096 27.2273 26.5156 25.7217C25.7152 26.6695 24.5194 27.2725 23.1816 27.2725C22.389 27.2724 21.6465 27.0599 21.0059 26.6904C19.239 28.4 16.8343 29.4541 14.1816 29.4541C8.75941 29.454 4.36348 25.0589 4.36328 19.6367C4.36328 18.4794 4.56491 17.3689 4.93262 16.3379C2.16508 16.0751 5.36239e-05 13.7455 0 10.9092C0 9.04504 0.935552 7.39982 2.3623 6.41602C0.997949 6.02154 0 4.7639 0 3.27246C0.000143911 1.46519 1.46519 0.000143911 3.27246 0Z",
    fill: "#E7F2FC",
    fillOpacity: 0.4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2278_14688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDay);
export default __webpack_public_path__ + "static/media/day.a0c12231cfd2231904e732ce652684d6.svg";
export { ForwardRef as ReactComponent };